import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CampusWard, ChurchUnitsDataService, SortService, CampusStake } from '../../shared';

@Component({
  selector: 'app-stake-wards-select',
  templateUrl: './stake-wards-select.component.html',
  styleUrls: ['./stake-wards-select.component.scss']
})
export class StakeWardsSelectComponent implements OnInit, OnChanges {
  @Input() stake: CampusStake = null;
  @Output() wardSelected: EventEmitter<CampusWard> = new EventEmitter();

  loading = false;
  wards: CampusWard[];
  _selectedWard: CampusWard;

  /**
   * Getter for our selected ward.
   */
  get selectedWard(): CampusWard {
    return this._selectedWard;
  }

  /**
   * Setter for our selected campus stake; when we set the ward to a real ward, clear out any selected campus ward.
   */
  set selectedWard(value: CampusWard) {
    this._selectedWard = value;
    this.wardSelected.emit(this.selectedWard);
  }

  constructor(
    private churchService: ChurchUnitsDataService,
    private sorter: SortService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    // since we only have one input parameter, we must have changed our stake, so reload the child units
    // ignore errors and don't show a loading bar
    if (this.stake) {
      this.loading = true;
      this.churchService
        .getStakeWards(this.stake.campusStakeId)
        .pipe(
          finalize(() => this.loading = false)
        )
        .subscribe(wards => {
          this.wards = wards;
          this.wards.sort(this.sorter.sortChurchUnitsAsc);

          if (this.wards.length > 0) {
            this.selectedWard = null;
          }
        });
    }
  }
}
